<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { Holiday } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import HolidayForm from './HolidayForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        holiday: Holiday;
    }>();

    const form = useForm({
        name: props.holiday.name,
        holiday_date: props.holiday.holiday_date,
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.salary.holidays.update', holiday.id)"
        method="patch"
        :query-key="[QueryKey.HOLIDAYS]"
        title="holidays.update"
    >
        <HolidayForm :form="form" />
    </DialogForm>
</template>
